import { DocumentsTable } from "components";

const Documents = ({ isProfileLocked = false }) => {

    return (
        <DocumentsTable isProfileLocked={isProfileLocked} />
    );

}
export default Documents;